class Header {
  constructor() {
    this.classes = {
      bodyScrolledUp: 'body-scrolled-up',
      bodyScrolledDownPastNav: 'body-scrolled-down-past-nav',
      bodyScrolledDownPastNavInitial: 'body-scrolled-down-past-nav-initial',
    };

    this.DOM = {
      body: document.body,
      header: document.getElementById('js-site-header-wrapper'),
      headerSizer: document.getElementById('js-site-header-sizer'),
    };

    if (!this.DOM.header) {
      return;
    }

    this.init();
  }

  getHeaderHeight() {
    return this.DOM.header.offsetHeight;
  }

  setSizer(headerHeight) {
    this.DOM.headerSizer.style.height = `${headerHeight}px`;
  }

  init() {
    const headerHeight = this.getHeaderHeight();
    this.setSizer(headerHeight);
    let lastScrollTop = 0;
    this.DOM.body.classList.add(
      this.classes.bodyScrolledDownPastNav,
      this.classes.bodyScrolledUp,
    );
    let locked = 0;
    document.body.addEventListener('lockNav', (e) => {
      const { isLocked } = e.detail;
      locked = isLocked;
    });
    window.addEventListener('scroll', () => {
      if (!locked) {
        const st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
          // scroll down
          this.DOM.body.classList.remove(this.classes.bodyScrolledUp);
          if (st > headerHeight) {
            this.DOM.body.classList.add(this.classes.bodyScrolledDownPastNav);
          }
        } else if (st > headerHeight) {
          // scroll up
          this.DOM.body.classList.add(this.classes.bodyScrolledUp);
        }
        lastScrollTop = st <= 0 ? 0 : st;
      }
    });
  }
}

export default new Header();
